import {
  Dialog as MUIDialog,
  DialogActions as MUIDialogActions,
  DialogContent as MUIDialogContent,
  DialogTitle as MUIDialogTitle,
} from "@mui/material";

export const Dialog = MUIDialog;
export const DialogActions = MUIDialogActions;
export const DialogContent = MUIDialogContent;
export const DialogTitle = MUIDialogTitle;
